// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const axis = "MonthlyBarChart__axis__QsEPE";
export const backBar = "MonthlyBarChart__backBar__jEWwm";
export const bar = "MonthlyBarChart__bar__M8GkG";
export const bars = "MonthlyBarChart__bars__XAz7P";
export const barsContainer = "MonthlyBarChart__barsContainer__w6Fdj";
export const bold = "700";
export const frontBar = "MonthlyBarChart__frontBar__jmjUP";
export const frontBarAtBottom = "MonthlyBarChart__frontBarAtBottom__W--y7";
export const frontBarAtBottomStrict = "MonthlyBarChart__frontBarAtBottomStrict__vpsFm";
export const frontBarAtTop = "MonthlyBarChart__frontBarAtTop__6mDYK";
export const frontBarAtTopStrict = "MonthlyBarChart__frontBarAtTopStrict__T5Ct3";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const hide = "MonthlyBarChart__hide__2QWpd";
export const light = "MonthlyBarChart__light__05g-L";
export const limitLabel = "MonthlyBarChart__limitLabel__0aLTP font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const limitLabelMovedDown = "MonthlyBarChart__limitLabelMovedDown__3Weix";
export const limitLabelMovedUp = "MonthlyBarChart__limitLabelMovedUp__imakp";
export const limitValue = "MonthlyBarChart__limitValue__vaBSL";
export const lineContainer = "MonthlyBarChart__lineContainer__W6MAn MonthlyBarChart__totalChartHeight__yo0To";
export const lineWrapper = "MonthlyBarChart__lineWrapper__dbhVb";
export const linesContainer = "MonthlyBarChart__linesContainer__brPME";
export const medium = "500";
export const member = "MonthlyBarChart__member__pc6Hy";
export const minorLineWrapper = "MonthlyBarChart__minorLineWrapper__4oZhS";
export const monthLabel = "MonthlyBarChart__monthLabel__dgK7E font-faces__sansSemibold__K6NQF font-faces__sans__uCf65";
export const monthlyBarChart = "MonthlyBarChart__monthlyBarChart__1AnMj font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const narrowBars = "MonthlyBarChart__narrowBars__fNrdX";
export const negative = "MonthlyBarChart__negative__GH9ms";
export const others = "MonthlyBarChart__others__ibOBo";
export const padded = "MonthlyBarChart__padded__-Lv9Y";
export const peers = "MonthlyBarChart__peers__dNK2M";
export const regular = "400";
export const sans = "'sans'";
export const selectedSingleMonthWrapper = "MonthlyBarChart__selectedSingleMonthWrapper__S50r+";
export const semibold = "600";
export const serif = "'serif'";
export const singleMonthWrapper = "MonthlyBarChart__singleMonthWrapper__rHwPP MonthlyBarChart__totalChartHeight__yo0To";
export const textCenter = "MonthlyBarChart__textCenter__RprmC";
export const thinBar = "MonthlyBarChart__thinBar__xdRId";
export const tiltedLabels = "MonthlyBarChart__tiltedLabels__BbXcB";
export const totalChartHeight = "MonthlyBarChart__totalChartHeight__yo0To";
export const value = "MonthlyBarChart__value__aXwwY";
export const withLegend = "MonthlyBarChart__withLegend__kJKK-";
export const withProjections = "MonthlyBarChart__withProjections__HKtgu";